import React, { useEffect, useState } from 'react'
import { Form, Input, Select, Button, Upload, Row, Col, DatePicker } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { SaveUserRegistrationApi } from "../API's/UserApi"
import axiosInstance from '../Utils/axiosInstance'
import { GetUserTypeData } from "../API's/AdminApi"

const { Option } = Select
const { TextArea } = Input

function UserRegistration() {
  const [form] = Form.useForm()
  const selectedUserType = Form.useWatch('userType', form)
  const [userTypes, setUserTypes] = useState([])

  const getUserTypes = async () => {
    try {
      const res = await axiosInstance.get(GetUserTypeData)

      setUserTypes(res.data || [])
    } catch (error) {
      toast.error('Failed to load user types')
    }
  }

  useEffect(() => {
    getUserTypes()
  }, [])

  const BUBBLES = [
    { w: 80, l: '5%', t: '15%', d: '0s' },
    { w: 120, l: '20%', t: '65%', d: '1.2s' },
    { w: 55, l: '72%', t: '20%', d: '2.4s' },
    { w: 160, l: '80%', t: '45%', d: '0.6s' },
    { w: 90, l: '40%', t: '82%', d: '1.8s' },
    { w: 140, l: '62%', t: '72%', d: '3.0s' },
  ]

  const [photo, setPhoto] = useState(null)
  const navigate = useNavigate()

  const onFinish = async (values) => {
    const formData = new FormData()

    formData.append('name', values.fullName)
    formData.append('gender', parseInt(values.gender))
    formData.append('mobileNo', parseInt(values.mobile))
    formData.append('emergencyMobNo', parseInt(values.emergencyMobile))
    formData.append('address', values.address)
    formData.append('aadhaarNo', parseInt(values.adharNo))
    formData.append('birthDate', values.birthDate.format('YYYY-MM-DD'))
    formData.append('userType', parseInt(values.userType))

    if (photo) {
      formData.append('photo', photo)
    }

    try {
      const res = await axios.post(SaveUserRegistrationApi, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      if (res.data === 'SAVED') {
        toast.success('User Registered Successfully')
        //  Clear form fields
        form.resetFields()
        navigate('/')

        //  Clear uploaded photo
        setPhoto(null)
      } else if (res.data === 'ALREADYEXISTS') {
        toast.warning('User already exists')
      } else {
        toast.error('Something went wrong')
      }
    } catch (error) {
      toast.error('Registration Failed')
    }
  }

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type.startsWith('image/')

      if (!isImage) {
        toast.error('You can only upload image files!')
        return Upload.LIST_IGNORE
      }

      const isLt1M = file.size / 1024 / 1024 < 1

      if (!isLt1M) {
        toast.error('Image must be smaller than 1MB!')
        return Upload.LIST_IGNORE
      }

      setPhoto(file)
      return false // prevent auto upload
    },
  }

  return (
    <div className="registration-page">
      {BUBBLES.map((b, i) => (
        <div
          key={i}
          className="hero-bubble"
          style={{
            width: b.w,
            height: b.w,
            left: b.l,
            top: b.t,
            animationDelay: b.d,
          }}
        />
      ))}
      <div
        className="registration-card"
        style={{ position: 'relative', zIndex: 1 }}
      >
        <h2 className="registration-title">User Registration</h2>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Full Name"
                name="fullName"
                rules={[{ required: true, message: 'Enter full name' }]}
              >
                <Input placeholder="Enter full name" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Gender"
                name="gender"
                rules={[
                  {
                    required: true,
                    message: 'Please select gender',
                  },
                ]}
              >
                <Select placeholder="Select gender">
                  <Option value="1">Male</Option>
                  <Option value="2">Female</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Mobile Number"
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: 'Please enter mobile number',
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Enter valid 10 digit mobile number',
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  placeholder="Enter mobile"
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '')
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Emergency Mobile Number"
                name="emergencyMobile"
                rules={[
                  {
                    required: true,
                    message: 'Please enter emergency mobile number',
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Enter valid 10 digit mobile number',
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  placeholder="Enter emergency mobile"
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '')
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={24}>
              <Form.Item
                label="Address"
                name="address"
                rules={[
                  {
                    required: true,
                    message: 'Please enter address',
                  },
                ]}
              >
                <TextArea rows={3} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="User Type"
                name="userType"
                rules={[
                  {
                    required: true,
                    message: 'Please select user type',
                  },
                ]}
              >
                <Select placeholder="Select user type">
                  {userTypes.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.userTypeName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12} hidden={selectedUserType == 1 ? true : false}>
              <Form.Item
                label="Aadhar Number"
                name="adharNo"
                rules={[
                  {
                    required: selectedUserType == 1 ? false : true,
                    message: 'Please enter Aadhar number',
                  },
                  {
                    pattern: /^\d{12}$/,
                    message: 'Aadhar must be 12 digits',
                  },
                ]}
              >
                <Input
                  maxLength={12}
                  placeholder="Enter Aadhar number"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault()
                    }
                  }}
                  onPaste={(e) => {
                    const paste = e.clipboardData.getData('text')
                    if (!/^\d+$/.test(paste)) {
                      e.preventDefault()
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Birth Date"
                name="birthDate"
                rules={[
                  {
                    required: true,
                    message: 'Please select birth date',
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%', padding: '10px' }}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} hidden={selectedUserType == 1 ? true : false}>
              <Form.Item
                label="Upload Photo"
                name="photo"
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e
                  }
                  return e && e.fileList
                }}
                rules={[
                  {
                    required: selectedUserType == 1 ? false : true,
                    message: 'Please upload a photo',
                  },
                ]}
              >
                <Upload
                  {...uploadProps}
                  maxCount={1}
                  accept="image/png,image/jpeg,image/jpg"
                  style={{ width: '100%' }}
                >
                  <Button icon={<UploadOutlined />} style={{ width: '100%' }}>
                    Select Photo
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={24} className="pt-3 text-end">
              <Form.Item>
                <Button
                  danger
                  className="cancel-btn"
                  onClick={() => {
                    form.resetFields()
                    setPhoto(null)
                    navigate('/')
                  }}
                >
                  Cancel
                </Button>

                <Button
                  style={{ marginLeft: 10 }}
                  type="primary"
                  htmlType="submit"
                  className="reg-submit-btn"
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default UserRegistration
